import React from "react";
import { FormattedMessage } from "react-intl";

const NotFound = () =>
    <h1><FormattedMessage id="not_found" /></h1>;

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound/index.js